import { render, staticRenderFns } from "./news.vue?vue&type=template&id=fda71ca6&scoped=true"
import script from "./news.vue?vue&type=script&lang=js"
export * from "./news.vue?vue&type=script&lang=js"
import style0 from "./news.vue?vue&type=style&index=0&id=fda71ca6&prod&lang=less&scoped=true"
import style1 from "./news.vue?vue&type=style&index=1&id=fda71ca6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda71ca6",
  null
  
)

export default component.exports